import { __rest } from 'tslib';
import React from 'react';
import { useTheme, useColor } from '@10d/tend-ui-theme';
import { extractMarginProps } from '@10d/tend-ui-styling';
import { Root as Root$1 } from './styled.js';

const Root = (_a) => {
    var { sticky = true, top, children, className, background = 'blue600' } = _a, props = __rest(_a, ["sticky", "top", "children", "className", "background"]);
    const theme = useTheme();
    // FIXME:  Исправить литеральные типы
    const _background = useColor(background);
    const margins = __rest(extractMarginProps(props), []);
    return (React.createElement(Root$1, Object.assign({ theme: theme, "$sticky": sticky, "$background": _background, "$top": top, className: [className, 'tend-ui-header-root'].filter(Boolean).join(' ') }, margins), children));
};
Root.displayName = 'Header.Root';

export { Root };
